import type { Traits } from "@segment/analytics-next";
import { use } from "react";

import { UserContext } from "@/contexts";
import { User } from "@/types";
import { analytics } from "@/utils/segment";

function useSegmentEvent() {
  const { user } = use(UserContext);

  const sendSegmentEvent = (
    eventName: string,
    extraParams: Record<string, string> = {}
  ) => {
    const payload: Record<string, string> = {
      event_text: eventName,
      ...extraParams,
    };

    let traits: Traits | undefined;
    if (user) {
      payload.email = user.email;
      payload.user_id = `bolo-${user.id}`;

      traits = generateUserTraits(user) as Traits;
    }

    // log segment event in dev mode
    if (import.meta.env.DEV) {
      console.info(`[Segment] ${eventName}`, payload);
    }

    analytics.track(eventName, payload, {
      context: { traits },
    });

    // send event to bolo backend
    if (user) {
      fetch("/api/client/platform_events", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }).then((response) => {
        if (!response.ok) {
          console.error(
            "Unable to log event to bolo backend:",
            response.statusText
          );
        }
      });
    }
  };

  return { sendSegmentEvent };
}

function generateUserTraits(user: User) {
  return {
    role: user.role,
    company_attributes: {
      plan: user.company.subscriptionType,
    },
  };
}

export default useSegmentEvent;
